import { render, staticRenderFns } from "./Open_button.vue?vue&type=template&id=e1087946"
import script from "./Open_button.vue?vue&type=script&lang=js"
export * from "./Open_button.vue?vue&type=script&lang=js"
import style0 from "./Open_button.vue?vue&type=style&index=0&id=e1087946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports